import { render, staticRenderFns } from "./SectionResourcesV2.vue?vue&type=template&id=289cac59&"
import script from "./SectionResourcesV2.vue?vue&type=script&lang=js&"
export * from "./SectionResourcesV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports